import React from 'react';
import styled from 'styled-components';
import { rgba } from 'polished';
import PropTypes from 'prop-types';

const CheckboxContainer = styled.div`
	display: inline-flex;
	align-items: center;
	vertical-align: middle;
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
	position: absolute;
	margin: -1px;
	padding: 0;
	width: 1px;
	height: 1px;
	overflow: hidden;
	white-space: nowrap;
	clip: rect(0 0 0 0);
	clip-path: inset(50%);
`;

const StyledCheckbox = styled.div`
	display: inline-block;
	transition: all 150ms;
	border-radius: 50%;
	background: ${({ theme, ...props }) => {
	return props.checked ? theme['blue-base'] : rgba(theme['white'], 0.2);
}};
	margin: 0.125rem;
	width: 0.75rem;
	height: 0.75rem;
	cursor: pointer;

	${HiddenCheckbox}:focus + & {
		box-shadow: 0 0 0 0.2rem ${({ theme }) => rgba(theme['blue-base'], 0.5)};
	}
`;

const CircleToggle = ({ className, checked, ...props }) => (
	<CheckboxContainer className={className}>
		<HiddenCheckbox checked={checked} {...props} />
		<StyledCheckbox checked={checked} />
	</CheckboxContainer>
);

CircleToggle.propTypes = {
	className: PropTypes.string,
	checked: PropTypes.bool
};

export default CircleToggle;
